module.exports = __webpack_public_path__ + "img/hokou-ai-2.fd61a8c6.svg";